









































import { Component, Vue, Prop } from "vue-property-decorator";
import {
    TableColumn,
    ResourceEntity,
    Resource,
    Claim
} from "@/services/security/types";
import i18n from "@/i18n";

@Component
export default class AccessControlTable extends Vue {
    @Prop() private Id!: string;
    @Prop() private resourceType!: string;
    @Prop() private resource!: Resource;

    // local state
    columns = [
        {
            key: "name",
            label: i18n.t("common.name")
        }
    ] as Array<TableColumn>;

    // filter options
    searchQuery = "";

    // lifecycle hooks
    public created() {
        this.prepareJsonClaims();
        this.createTableColumns();
    }

    // computed
    get filteredData() {
        return (
            this.resource.resourceEntities &&
            this.resource.resourceEntities.filter(
                x =>
                    this.searchQuery.length === 0 ||
                    x.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            )
        );
    }

    // methods
    backBtn() {
        this.$router.push({
            name: "UserGroups"
        });
    }

    createTableColumns() {
        const name: string = this.resourceType;
        let claims = [] as Array<Claim>;
        if (
            this.resource &&
            this.resource.resourceEntities[0] &&
            this.resource.resourceEntities[0].claims
        ) {
            claims = this.resource.resourceEntities[0].claims;
        }
        const newColumns: Array<TableColumn> = [];

        claims.forEach(function (k) {
            const newColumn = {
                key: k.name,
                label: i18n.t("acl." + `${k.name}`.toLowerCase()).toString(),
                colType: "checkbox"
            };
            newColumns.push(newColumn);
        });

        this.columns = this.columns.concat(newColumns);
    }

    updateResourceEntity(data: ResourceEntity, resourceType: string) {
        this.$emit("updateResourceEntity", data, resourceType);
    }

    prepareJsonClaims() {
        let jsonClaims: {
            [key: string]: boolean;
        } = {};
        this.resource.resourceEntities.forEach(function (resEntity) {
            resEntity.claims.forEach(function (element: Claim) {
                jsonClaims[element.name] = element.value;
            });
            resEntity.jsonClaims = jsonClaims;
            jsonClaims = {};
        });
    }
}
